import { emailRegExpMatcher } from '@fv/client-core'
import type { ShipmentShare } from '@fv/client-types'

import type { ShipmentLocationFormModel } from '@/features/shipment-location-form/types'
import type { ApiQuoteRequestDTO } from '@/types'

export const parseShareEmails = (value: string): string[] =>
  value.match(emailRegExpMatcher) ?? []

export const buildSharesDto = (
  shares: string,
  locations: ShipmentLocationFormModel[],
): ShipmentShare[] => {
  const rootShares = parseShareEmails(shares).map<ShipmentShare>(email => ({
    email,
    role: 'share',
    status: 'queued',
  }))

  const locationShares = locations
    .filter(x => x.copyBOL)
    .flatMap<ShipmentShare>(x =>
      parseShareEmails(x.shares).map(email => ({
        email,
        role: x.type,
        sequence: x.sequence,
        status: 'queued',
      })),
    )

  return [...rootShares, ...locationShares]
}

export const buildQuoteRequestShares = (
  locations: ShipmentLocationFormModel[],
): Pick<ApiQuoteRequestDTO, 'shares'> => {
  const shares = buildSharesDto('', locations)
  return shares.length ? { shares } : {}
}
